module.exports = __webpack_public_path__ + "eb438d39a52148721dbecd411567fb77.png";